import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Notification } from '../../../../shared/src/types/Notification';

interface NotificationState {
  allNotifications: Notification[];
}
const initialState: NotificationState = {
  allNotifications: [],
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setAllNotifications(state, action: PayloadAction<Notification[]>) {
      state.allNotifications = action.payload;
    },
    addNotification(state, action: PayloadAction<Notification>) {
      state.allNotifications.unshift(action.payload);
    },
    updateNotification(state, action: PayloadAction<Notification>) {
      const updated = action.payload;
      state.allNotifications = state.allNotifications.map(n =>
        n.id === updated.id ? updated : n
      );
    },
    deleteNotification(state, action: PayloadAction<string>) {
      state.allNotifications = state.allNotifications.filter(n => n.id !== action.payload);
    },
  },
});

export const {
  setAllNotifications,
  addNotification,
  updateNotification,
  deleteNotification,
} = notificationSlice.actions;

export const selectAllNotifications = (state: { notifications: NotificationState }): Notification[] =>
  state.notifications.allNotifications;

export const selectNotificationById = (_id: string) => (state: { notifications: NotificationState }): Notification | undefined =>
  state.notifications.allNotifications.find(n => n.id === _id);

export default notificationSlice.reducer;
